export const ENS_GRAPH_ENDPOINT = 'https://api.thegraph.com/subgraphs/name/ensdomains/ens';
